module.exports = __webpack_public_path__ + "static/media/dancing-man.story.e64969c6.jpg";